// import React, { useState } from "react";
// import "../../../assets/css/student/StudentHelpSupport.css";
// import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";


// // ─── SVG ICONS ──────────────────────────────────────────────────────────────

// const SearchIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <circle cx="11" cy="11" r="8" />
//     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );

// const ArrowRightIcon = ({ size = 16 }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <line x1="5" y1="12" x2="19" y2="12" />
//     <polyline points="12 5 19 12 12 19" />
//   </svg>
// );

// const ChevronDownIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="6 9 12 15 18 9" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <line x1="18" y1="6" x2="6" y2="18" />
//     <line x1="6" y1="6" x2="18" y2="18" />
//   </svg>
// );

// const CheckIcon = ({ size = 28 }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="2.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="20 6 9 17 4 12" />
//   </svg>
// );

// const ChatIcon = ({ size = 22 }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
//   </svg>
// );

// const AlertIcon = ({ size = 22 }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
//     <line x1="12" y1="8" x2="12" y2="12" />
//     <line x1="12" y1="16" x2="12.01" y2="16" />
//   </svg>
// );

// const CardIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
//     <line x1="1" y1="10" x2="23" y2="10" />
//   </svg>
// );

// const MentorIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//     <circle cx="9" cy="7" r="4" />
//     <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//     <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//   </svg>
// );

// const BookIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
//     <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
//   </svg>
// );

// const BugIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M8 2l1.5 1.5" />
//     <path d="M14.5 3.5L16 2" />
//     <path d="M9 7.5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0V7.5Z" />
//     <path d="M6 11H3" />
//     <path d="M21 11h-3" />
//     <path d="M9 14H6l-2 3" />
//     <path d="M15 14h3l2 3" />
//     <path d="M9 7.5H6" />
//     <path d="M15 7.5h3" />
//   </svg>
// );

// const BillingCatIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="1" y="4" width="22" height="16" rx="2" />
//     <line x1="1" y1="10" x2="23" y2="10" />
//   </svg>
// );

// const MentorshipIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//     <circle cx="9" cy="7" r="4" />
//     <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//     <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//   </svg>
// );

// const CoursesIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
//     <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
//   </svg>
// );

// const TechIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="16 18 22 12 16 6" />
//     <polyline points="8 6 2 12 8 18" />
//   </svg>
// );

// const SettingsIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <circle cx="12" cy="12" r="3" />
//     <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
//   </svg>
// );

// const PaymentIssueIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="1" y="4" width="22" height="16" rx="2" />
//     <line x1="1" y1="10" x2="23" y2="10" />
//   </svg>
// );

// const TicketIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
//     <line x1="9" y1="9" x2="9" y2="15" />
//     <line x1="15" y1="9" x2="15" y2="15" />
//   </svg>
// );

// // ─── DATA ────────────────────────────────────────────────────────────────────

// const FAQ_ITEMS = [
//   {
//     q: "How do I reschedule a mentor session?",
//     a: 'Go to My Sessions in your dashboard. Click on the session you want to reschedule and select "Reschedule." You can pick a new time up to 24 hours before the session starts. Cancellations within 24 hours may incur a fee.',
//   },
//   {
//     q: "Why was my payment declined?",
//     a: "Payments can fail due to insufficient funds, an expired card, or a mismatch in billing details. Check that your card details are correct in Settings > Payment Methods. If the issue persists, contact your bank or reach out to our support team.",
//   },
//   {
//     q: "How do I access course materials after completion?",
//     a: "All purchased course materials are permanently available in your Library. Navigate to My Courses > Completed and click on any course to access videos, notes, and resources without time limits.",
//   },
//   {
//     q: "Can I switch my mentor mid-program?",
//     a: "Yes — you can request a mentor change from your program dashboard at any time. Go to My Mentors > Request Change and fill in your reason. Switches are usually processed within 2 business days.",
//   },
//   {
//     q: "How do I get a certificate for a completed course?",
//     a: "Certificates are auto-generated when you reach 100% course completion and pass the final assessment (if applicable). Find yours in Profile > Certificates & Credentials. You can share them directly to LinkedIn.",
//   },
//   {
//     q: "What are Tech Mentor Hub's refund policies?",
//     a: "We offer a 7-day money-back guarantee on all course purchases. Mentorship session refunds are available up to 48 hours before the session. Subscriptions can be cancelled anytime but are non-refundable mid-cycle.",
//   },
// ];

// const TICKETS = [
//   {
//     id: "#T-2841",
//     subject: "Payment failed for Advanced React course",
//     type: "Payment",
//     date: "Apr 10, 2026",
//     status: "urgent",
//   },
//   {
//     id: "#T-2790",
//     subject: "Mentor session recording not available",
//     type: "Mentorship",
//     date: "Apr 8, 2026",
//     status: "pending",
//   },
//   {
//     id: "#T-2743",
//     subject: "Certificate not generated after completion",
//     type: "Course",
//     date: "Apr 5, 2026",
//     status: "resolved",
//   },
//   {
//     id: "#T-2701",
//     subject: "Login issue on mobile browser (Safari)",
//     type: "Technical",
//     date: "Apr 2, 2026",
//     status: "resolved",
//   },
// ];

// const ISSUE_OPTS = [
//   {
//     id: "payment",
//     label: "Payment Issue",
//     icon: <PaymentIssueIcon />,
//     bg: "#EFF6FF",
//     color: "#2563EB",
//   },
//   {
//     id: "mentor",
//     label: "Mentor Issue",
//     icon: <MentorshipIcon />,
//     bg: "#F5F3FF",
//     color: "#7C3AED",
//   },
//   {
//     id: "bug",
//     label: "Technical Bug",
//     icon: <TechIcon />,
//     bg: "#FEF2F2",
//     color: "#DC2626",
//   },
//   {
//     id: "other",
//     label: "Other",
//     icon: <SettingsIcon />,
//     bg: "#F0FDF4",
//     color: "#059669",
//   },
// ];


// // ─── HERO ────────────────────────────────────────────────────────────────────

// const HeroSection = ({ query, setQuery }) => (
//   <div className="hs-hero">
//     <div className="hs-hero-noise" />
//     <div className="hs-hero-inner">
//       <div className="hs-hero-badge">
//         <span className="hs-hero-badge-dot" />
//         Support Center
//       </div>
//       <h1>Help &amp; Support</h1>
//       <p>
//         Find instant answers, manage your sessions, or talk to a real human. We
//         have got you covered.
//       </p>
//       <div className="hs-search-wrap">
//         <span className="hs-search-icon">
//           <SearchIcon />
//         </span>
//         <input
//           className="hs-search-input"
//           type="text"
//           placeholder="Search for answers — payments, mentors, courses..."
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//         />
//         <button className="hs-search-btn">Search</button>
//       </div>
//       <div className="hs-search-tags">
//         {[
//           "How to cancel",
//           "Refund policy",
//           "Reschedule session",
//           "Download certificate",
//         ].map((t) => (
//           <button key={t} className="hs-search-tag" onClick={() => setQuery(t)}>
//             <SearchIcon />
//             {t}
//           </button>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// // ─── QUICK ACTION CARDS ──────────────────────────────────────────────────────

// const ACTIONS = [
//   {
//     color: "blue",
//     title: "Payment Issues",
//     desc: "Fix billing errors, failed payments, and refund requests instantly.",
//     icon: <CardIcon />,
//   },
//   {
//     color: "purple",
//     title: "Mentor Help",
//     desc: "Reschedule sessions, switch mentors, or report conduct concerns.",
//     icon: <MentorIcon />,
//   },
//   {
//     color: "green",
//     title: "Course Help",
//     desc: "Access materials, get certificates, or troubleshoot course content.",
//     icon: <BookIcon />,
//   },
//   {
//     color: "orange",
//     title: "Report a Bug",
//     desc: "Found a technical issue? Let us know and we will fix it fast.",
//     icon: <BugIcon />,
//   },
// ];

// const QuickActions = ({ onReport }) => (
//   <section className="hs-section">
//     <div className="hs-section-header">
//       <span className="hs-section-label">Quick Actions</span>
//       <h2 className="hs-section-title">What can we help you with?</h2>
//       <p className="hs-section-sub">
//         Jump directly to the most common support topics.
//       </p>
//     </div>
//     <div className="hs-actions-grid">
//       {ACTIONS.map((a) => (
//         <button
//           key={a.title}
//           className={`hs-action-card hs-action-card--${a.color}`}
//           onClick={() => a.color === "orange" && onReport()}
//         >
//           <div className="hs-action-bg-circle" />
//           <div className="hs-action-icon">{a.icon}</div>
//           <h3>{a.title}</h3>
//           <p>{a.desc}</p>
//           <span className="hs-action-arrow">
//             <ArrowRightIcon size={18} />
//           </span>
//         </button>
//       ))}
//     </div>
//   </section>
// );

// // ─── HELP CATEGORIES ─────────────────────────────────────────────────────────

// const CATS = [
//   {
//     label: "Payments & Billing",
//     count: "14 articles",
//     cls: "blue",
//     icon: <BillingCatIcon />,
//   },
//   {
//     label: "Mentorship & Sessions",
//     count: "9 articles",
//     cls: "purple",
//     icon: <MentorshipIcon />,
//   },
//   {
//     label: "Courses & Learning",
//     count: "21 articles",
//     cls: "green",
//     icon: <CoursesIcon />,
//   },
//   {
//     label: "Technical Issues",
//     count: "11 articles",
//     cls: "red",
//     icon: <TechIcon />,
//   },
//   {
//     label: "Account Settings",
//     count: "7 articles",
//     cls: "amber",
//     icon: <SettingsIcon />,
//   },
// ];

// const HelpCategories = () => (
//   <section className="hs-section" style={{ paddingTop: 0 }}>
//     <div className="hs-section-header">
//       <span className="hs-section-label">Browse</span>
//       <h2 className="hs-section-title">Help Categories</h2>
//       <p className="hs-section-sub">
//         Explore our curated knowledge base by topic.
//       </p>
//     </div>
//     <div className="hs-categories-grid">
//       {CATS.map((c) => (
//         <div className="hs-cat-card" key={c.label}>
//           <div className={`hs-cat-icon hs-cat-icon--${c.cls}`}>{c.icon}</div>
//           <h4>{c.label}</h4>
//           <span className="hs-cat-count">{c.count}</span>
//         </div>
//       ))}
//     </div>
//   </section>
// );

// // ─── FAQ ─────────────────────────────────────────────────────────────────────

// const FaqItem = ({ item, open, toggle }) => (
//   <div className={`hs-faq-item${open ? " hs-faq-item--open" : ""}`}>
//     <button className="hs-faq-q" onClick={toggle}>
//       <span className="hs-faq-q-text">{item.q}</span>
//       <span className="hs-faq-chevron">
//         <ChevronDownIcon />
//       </span>
//     </button>
//     <div className="hs-faq-body">
//       <p className="hs-faq-a">{item.a}</p>
//     </div>
//   </div>
// );

// const FaqSection = () => {
//   const [openIdx, setOpenIdx] = useState(0);
//   return (
//     <section className="hs-section" style={{ paddingTop: 0 }}>
//       <div className="hs-section-header">
//         <span className="hs-section-label">Knowledge Base</span>
//         <h2 className="hs-section-title">Frequently Asked Questions</h2>
//         <p className="hs-section-sub">
//           Quick answers to the questions we hear most often.
//         </p>
//       </div>
//       <div className="hs-faq-list">
//         {FAQ_ITEMS.map((item, i) => (
//           <FaqItem
//             key={i}
//             item={item}
//             open={openIdx === i}
//             toggle={() => setOpenIdx(openIdx === i ? null : i)}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// // ─── STILL NEED HELP ─────────────────────────────────────────────────────────

// const StillNeedHelp = ({ onReport }) => (
//   <section className="hs-section" style={{ paddingTop: 0 }}>
//     <div className="hs-help-cta">
//       <div className="hs-help-cta-inner">
//         <h2>Still need help?</h2>
//         <p>
//           Our support team is online and ready to help you resolve any issue —
//           usually within a few minutes.
//         </p>
//         <div className="hs-help-cta-btns">
//           <button className="hs-btn hs-btn--primary">
//             <ChatIcon size={16} /> Chat with Support
//           </button>
//           <button className="hs-btn hs-btn--accent" onClick={onReport}>
//             <AlertIcon size={16} /> Report an Issue
//           </button>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ─── SUPPORT TICKETS ─────────────────────────────────────────────────────────

// const StatusBadge = ({ status }) => (
//   <span className={`hs-badge hs-badge--${status}`}>
//     <span className="hs-badge-dot" />
//     {status.charAt(0).toUpperCase() + status.slice(1)}
//   </span>
// );

// const MyTickets = () => (
//   <section className="hs-section" style={{ paddingTop: 0 }}>
//     <div className="hs-section-header">
//       <span className="hs-section-label">Your Activity</span>
//       <h2 className="hs-section-title">My Support Tickets</h2>
//       <p className="hs-section-sub">
//         Track the status of all your submitted requests.
//       </p>
//     </div>
//     <div className="hs-tickets-table">
//       <div className="hs-tickets-head">
//         <span className="hs-th">Ticket ID</span>
//         <span className="hs-th">Subject</span>
//         <span className="hs-th">Type</span>
//         <span className="hs-th">Date</span>
//         <span className="hs-th">Status</span>
//       </div>
//       {TICKETS.map((t) => (
//         <div className="hs-ticket-row" key={t.id}>
//           <span className="hs-ticket-id">
//             <TicketIcon /> {t.id}
//           </span>
//           <span className="hs-ticket-subject">{t.subject}</span>
//           <span className="hs-ticket-type">{t.type}</span>
//           <span className="hs-ticket-date">{t.date}</span>
//           <StatusBadge status={t.status} />
//         </div>
//       ))}
//     </div>
//   </section>
// );

// // ─── REPORT MODAL ────────────────────────────────────────────────────────────

// const STEPS = ["Select Type", "Describe Issue", "Submit"];

// const ReportModal = ({ onClose }) => {
//   const [step, setStep] = useState(0);
//   const [selected, setSelected] = useState(null);
//   const [desc, setDesc] = useState("");
//   const [done, setDone] = useState(false);

//   const submit = () => {
//     if (step === 0 && !selected) return;
//     if (step === 1 && !desc.trim()) return;
//     if (step < 2) {
//       setStep((s) => s + 1);
//       return;
//     }
//     setDone(true);
//   };

//   const stepState = (i) => (i < step ? "done" : i === step ? "active" : "idle");

//   return (
//     <div
//       className="hs-modal-overlay"
//       onClick={(e) => e.target === e.currentTarget && onClose()}
//     >
//       <div className="hs-modal">
//         <button className="hs-modal-close" onClick={onClose}>
//           <CloseIcon />
//         </button>

//         {done ? (
//           <div className="hs-modal-success">
//             <div className="hs-success-icon">
//               <CheckIcon />
//             </div>
//             <h3>Issue Reported</h3>
//             <p>
//               Your ticket has been created and our team will reach out within 30
//               minutes. Check My Tickets for updates.
//             </p>
//             <div className="hs-modal-footer">
//               <button className="hs-btn hs-btn--primary" onClick={onClose}>
//                 Done
//               </button>
//             </div>
//           </div>
//         ) : (
//           <>
//             <p className="hs-modal-title">Report an Issue</p>
//             <p className="hs-modal-sub">
//               We will get back to you within 30 minutes.
//             </p>

//             {/* Steps */}
//             <div className="hs-steps">
//               {STEPS.map((label, i) => (
//                 <div key={label} className={`hs-step hs-step--${stepState(i)}`}>
//                   <div className="hs-step-dot">
//                     {stepState(i) === "done" ? <CheckIcon size={12} /> : i + 1}
//                   </div>
//                   <span className="hs-step-label">{label}</span>
//                 </div>
//               ))}
//             </div>

//             {/* Step 0 */}
//             {step === 0 && (
//               <div className="hs-issue-opts">
//                 {ISSUE_OPTS.map((opt) => (
//                   <button
//                     key={opt.id}
//                     className={`hs-issue-opt${selected === opt.id ? " hs-issue-opt--selected" : ""}`}
//                     onClick={() => setSelected(opt.id)}
//                   >
//                     <div
//                       className="hs-issue-opt-icon"
//                       style={{ background: opt.bg, color: opt.color }}
//                     >
//                       {opt.icon}
//                     </div>
//                     <span>{opt.label}</span>
//                   </button>
//                 ))}
//               </div>
//             )}

//             {/* Step 1 */}
//             {step === 1 && (
//               <textarea
//                 className="hs-textarea"
//                 placeholder="Describe your issue in detail — what happened, when, and any error messages you saw..."
//                 value={desc}
//                 onChange={(e) => setDesc(e.target.value)}
//               />
//             )}

//             {/* Step 2 */}
//             {step === 2 && (
//               <div style={{ marginBottom: 24 }}>
//                 <div
//                   style={{
//                     background: "#F5F3FF",
//                     borderRadius: 12,
//                     padding: "16px 20px",
//                     marginBottom: 12,
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: 12,
//                       color: "#7C3AED",
//                       fontWeight: 700,
//                       marginBottom: 4,
//                       fontFamily: "Syne, sans-serif",
//                       letterSpacing: "0.06em",
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Issue Type
//                   </div>
//                   <div style={{ fontSize: 14, color: "#0F0E17" }}>
//                     {ISSUE_OPTS.find((o) => o.id === selected)?.label}
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     background: "#F5F3FF",
//                     borderRadius: 12,
//                     padding: "16px 20px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: 12,
//                       color: "#7C3AED",
//                       fontWeight: 700,
//                       marginBottom: 4,
//                       fontFamily: "Syne, sans-serif",
//                       letterSpacing: "0.06em",
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Description
//                   </div>
//                   <div
//                     style={{ fontSize: 14, color: "#0F0E17", lineHeight: 1.6 }}
//                   >
//                     {desc}
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="hs-modal-footer">
//               {step > 0 && (
//                 <button
//                   className="hs-btn hs-btn--ghost"
//                   style={{ background: "#F1F0F5", color: "#6B6882" }}
//                   onClick={() => setStep((s) => s - 1)}
//                 >
//                   Back
//                 </button>
//               )}
//               <button
//                 className="hs-btn hs-btn--primary"
//                 onClick={submit}
//                 disabled={
//                   (step === 0 && !selected) || (step === 1 && !desc.trim())
//                 }
//                 style={{
//                   opacity:
//                     (step === 0 && !selected) || (step === 1 && !desc.trim())
//                       ? 0.5
//                       : 1,
//                 }}
//               >
//                 {step === 2 ? "Submit Report" : "Continue"}{" "}
//                 <ArrowRightIcon size={14} />
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// // ─── ROOT COMPONENT ──────────────────────────────────────────────────────────

// const HelpSupportPage = () => {
//   const [query, setQuery] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);

//   return (
//     <MyStudentLayout>
//       <div className="hs-page">
//         <HeroSection query={query} setQuery={setQuery} />
//         <QuickActions onReport={() => setModalOpen(true)} />
//         <HelpCategories />
//         <FaqSection />
//         <StillNeedHelp onReport={() => setModalOpen(true)} />
//         <MyTickets />

//         {modalOpen && <ReportModal onClose={() => setModalOpen(false)} />}
//       </div>
//     </MyStudentLayout>
//   );
// };

// export default HelpSupportPage;



import React, { useState } from "react";
import "../../../assets/css/student/StudentHelpSupport.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";


// ─── SVG ICONS ──────────────────────────────────────────────────────────────

const ArrowRightIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const CheckIcon = ({ size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ChatIcon = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const AlertIcon = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const CardIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const MentorIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BookIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const BugIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 2l1.5 1.5" />
    <path d="M14.5 3.5L16 2" />
    <path d="M9 7.5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0V7.5Z" />
    <path d="M6 11H3" />
    <path d="M21 11h-3" />
    <path d="M9 14H6l-2 3" />
    <path d="M15 14h3l2 3" />
    <path d="M9 7.5H6" />
    <path d="M15 7.5h3" />
  </svg>
);

const BillingCatIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const MentorshipIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const CoursesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const TechIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

const SettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const PaymentIssueIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const TicketIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
    <line x1="9" y1="9" x2="9" y2="15" />
    <line x1="15" y1="9" x2="15" y2="15" />
  </svg>
);

// ─── DATA ────────────────────────────────────────────────────────────────────

const FAQ_ITEMS = [
  {
    q: "How do I reschedule a mentor session?",
    a: 'Go to My Sessions in your dashboard. Click on the session you want to reschedule and select "Reschedule." You can pick a new time up to 24 hours before the session starts. Cancellations within 24 hours may incur a fee.',
  },
  {
    q: "Why was my payment declined?",
    a: "Payments can fail due to insufficient funds, an expired card, or a mismatch in billing details. Check that your card details are correct in Settings > Payment Methods. If the issue persists, contact your bank or reach out to our support team.",
  },
  {
    q: "How do I access course materials after completion?",
    a: "All purchased course materials are permanently available in your Library. Navigate to My Courses > Completed and click on any course to access videos, notes, and resources without time limits.",
  },
  {
    q: "Can I switch my mentor mid-program?",
    a: "Yes — you can request a mentor change from your program dashboard at any time. Go to My Mentors > Request Change and fill in your reason. Switches are usually processed within 2 business days.",
  },
  {
    q: "How do I get a certificate for a completed course?",
    a: "Certificates are auto-generated when you reach 100% course completion and pass the final assessment (if applicable). Find yours in Profile > Certificates & Credentials. You can share them directly to LinkedIn.",
  },
  {
    q: "What are Tech Mentor Hub's refund policies?",
    a: "We offer a 7-day money-back guarantee on all course purchases. Mentorship session refunds are available up to 48 hours before the session. Subscriptions can be cancelled anytime but are non-refundable mid-cycle.",
  },
];

const TICKETS = [
  {
    id: "#T-2841",
    subject: "Payment failed for Advanced React course",
    type: "Payment",
    date: "Apr 10, 2026",
    status: "urgent",
  },
  {
    id: "#T-2790",
    subject: "Mentor session recording not available",
    type: "Mentorship",
    date: "Apr 8, 2026",
    status: "pending",
  },
  {
    id: "#T-2743",
    subject: "Certificate not generated after completion",
    type: "Course",
    date: "Apr 5, 2026",
    status: "resolved",
  },
  {
    id: "#T-2701",
    subject: "Login issue on mobile browser (Safari)",
    type: "Technical",
    date: "Apr 2, 2026",
    status: "resolved",
  },
];

const ISSUE_OPTS = [
  {
    id: "payment",
    label: "Payment Issue",
    icon: <PaymentIssueIcon />,
    bg: "#EFF6FF",
    color: "#2563EB",
  },
  {
    id: "mentor",
    label: "Mentor Issue",
    icon: <MentorshipIcon />,
    bg: "#F5F3FF",
    color: "#7C3AED",
  },
  {
    id: "bug",
    label: "Technical Bug",
    icon: <TechIcon />,
    bg: "#FEF2F2",
    color: "#DC2626",
  },
  {
    id: "other",
    label: "Other",
    icon: <SettingsIcon />,
    bg: "#F0FDF4",
    color: "#059669",
  },
];

// ─── QUICK ACTION CARDS ──────────────────────────────────────────────────────

const ACTIONS = [
  {
    color: "blue",
    title: "Payment Issues",
    desc: "Fix billing errors, failed payments, and refund requests instantly.",
    icon: <CardIcon />,
  },
  {
    color: "purple",
    title: "Mentor Help",
    desc: "Reschedule sessions, switch mentors, or report conduct concerns.",
    icon: <MentorIcon />,
  },
  {
    color: "green",
    title: "Course Help",
    desc: "Access materials, get certificates, or troubleshoot course content.",
    icon: <BookIcon />,
  },
  {
    color: "orange",
    title: "Report a Bug",
    desc: "Found a technical issue? Let us know and we will fix it fast.",
    icon: <BugIcon />,
  },
];

const QuickActions = ({ onReport }) => (
  <section className="hs-section">
    <div className="hs-section-header">
      <span className="hs-section-label">Quick Actions</span>
      <h2 className="hs-section-title">What can we help you with?</h2>
      <p className="hs-section-sub">
        Jump directly to the most common support topics.
      </p>
    </div>
    <div className="hs-actions-grid">
      {ACTIONS.map((a) => (
        <button
          key={a.title}
          className={`hs-action-card hs-action-card--${a.color}`}
          onClick={() => a.color === "orange" && onReport()}
        >
          <div className="hs-action-bg-circle" />
          <div className="hs-action-icon">{a.icon}</div>
          <h3>{a.title}</h3>
          <p>{a.desc}</p>
          <span className="hs-action-arrow">
            <ArrowRightIcon size={18} />
          </span>
        </button>
      ))}
    </div>
  </section>
);

// ─── HELP CATEGORIES ─────────────────────────────────────────────────────────

const CATS = [
  {
    label: "Payments & Billing",
    count: "14 articles",
    cls: "blue",
    icon: <BillingCatIcon />,
  },
  {
    label: "Mentorship & Sessions",
    count: "9 articles",
    cls: "purple",
    icon: <MentorshipIcon />,
  },
  {
    label: "Courses & Learning",
    count: "21 articles",
    cls: "green",
    icon: <CoursesIcon />,
  },
  {
    label: "Technical Issues",
    count: "11 articles",
    cls: "red",
    icon: <TechIcon />,
  },
  {
    label: "Account Settings",
    count: "7 articles",
    cls: "amber",
    icon: <SettingsIcon />,
  },
];

const HelpCategories = () => (
  <section className="hs-section" style={{ paddingTop: 0 }}>
    <div className="hs-section-header">
      <span className="hs-section-label">Browse</span>
      <h2 className="hs-section-title">Help Categories</h2>
      <p className="hs-section-sub">
        Explore our curated knowledge base by topic.
      </p>
    </div>
    <div className="hs-categories-grid">
      {CATS.map((c) => (
        <div className="hs-cat-card" key={c.label}>
          <div className={`hs-cat-icon hs-cat-icon--${c.cls}`}>{c.icon}</div>
          <h4>{c.label}</h4>
          <span className="hs-cat-count">{c.count}</span>
        </div>
      ))}
    </div>
  </section>
);

// ─── FAQ ─────────────────────────────────────────────────────────────────────

const FaqItem = ({ item, open, toggle }) => (
  <div className={`hs-faq-item${open ? " hs-faq-item--open" : ""}`}>
    <button className="hs-faq-q" onClick={toggle}>
      <span className="hs-faq-q-text">{item.q}</span>
      <span className="hs-faq-chevron">
        <ChevronDownIcon />
      </span>
    </button>
    <div className="hs-faq-body">
      <p className="hs-faq-a">{item.a}</p>
    </div>
  </div>
);

const FaqSection = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section className="hs-section" style={{ paddingTop: 0 }}>
      <div className="hs-section-header">
        <span className="hs-section-label">Knowledge Base</span>
        <h2 className="hs-section-title">Frequently Asked Questions</h2>
        <p className="hs-section-sub">
          Quick answers to the questions we hear most often.
        </p>
      </div>
      <div className="hs-faq-list">
        {FAQ_ITEMS.map((item, i) => (
          <FaqItem
            key={i}
            item={item}
            open={openIdx === i}
            toggle={() => setOpenIdx(openIdx === i ? null : i)}
          />
        ))}
      </div>
    </section>
  );
};

// ─── STILL NEED HELP ─────────────────────────────────────────────────────────

const StillNeedHelp = ({ onReport }) => (
  <section className="hs-section" style={{ paddingTop: 0 }}>
    <div className="hs-help-cta">
      <div className="hs-help-cta-inner">
        <h2>Still need help?</h2>
        <p>
          Our support team is online and ready to help you resolve any issue —
          usually within a few minutes.
        </p>
        <div className="hs-help-cta-btns">
          <button className="hs-btn hs-btn--primary">
            <ChatIcon size={16} /> Chat with Support
          </button>
          <button className="hs-btn hs-btn--accent" onClick={onReport}>
            <AlertIcon size={16} /> Report an Issue
          </button>
        </div>
      </div>
    </div>
  </section>
);

// ─── SUPPORT TICKETS ─────────────────────────────────────────────────────────

const StatusBadge = ({ status }) => (
  <span className={`hs-badge hs-badge--${status}`}>
    <span className="hs-badge-dot" />
    {status.charAt(0).toUpperCase() + status.slice(1)}
  </span>
);

const MyTickets = () => (
  <section className="hs-section" style={{ paddingTop: 0 }}>
    <div className="hs-section-header">
      <span className="hs-section-label">Your Activity</span>
      <h2 className="hs-section-title">My Support Tickets</h2>
      <p className="hs-section-sub">
        Track the status of all your submitted requests.
      </p>
    </div>
    <div className="hs-tickets-table">
      <div className="hs-tickets-head">
        <span className="hs-th">Ticket ID</span>
        <span className="hs-th">Subject</span>
        <span className="hs-th">Type</span>
        <span className="hs-th">Date</span>
        <span className="hs-th">Status</span>
      </div>
      {TICKETS.map((t) => (
        <div className="hs-ticket-row" key={t.id}>
          <span className="hs-ticket-id">
            <TicketIcon /> {t.id}
          </span>
          <span className="hs-ticket-subject">{t.subject}</span>
          <span className="hs-ticket-type">{t.type}</span>
          <span className="hs-ticket-date">{t.date}</span>
          <StatusBadge status={t.status} />
        </div>
      ))}
    </div>
  </section>
);

// ─── REPORT MODAL ────────────────────────────────────────────────────────────

const STEPS = ["Select Type", "Describe Issue", "Submit"];

const ReportModal = ({ onClose }) => {
  const [step, setStep] = useState(0);
  const [selected, setSelected] = useState(null);
  const [desc, setDesc] = useState("");
  const [done, setDone] = useState(false);

  const submit = () => {
    if (step === 0 && !selected) return;
    if (step === 1 && !desc.trim()) return;
    if (step < 2) {
      setStep((s) => s + 1);
      return;
    }
    setDone(true);
  };

  const stepState = (i) => (i < step ? "done" : i === step ? "active" : "idle");

  return (
    <div
      className="hs-modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="hs-modal">
        <button className="hs-modal-close" onClick={onClose}>
          <CloseIcon />
        </button>

        {done ? (
          <div className="hs-modal-success">
            <div className="hs-success-icon">
              <CheckIcon />
            </div>
            <h3>Issue Reported</h3>
            <p>
              Your ticket has been created and our team will reach out within 30
              minutes. Check My Tickets for updates.
            </p>
            <div className="hs-modal-footer">
              <button className="hs-btn hs-btn--primary" onClick={onClose}>
                Done
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="hs-modal-title">Report an Issue</p>
            <p className="hs-modal-sub">
              We will get back to you within 30 minutes.
            </p>

            {/* Steps */}
            <div className="hs-steps">
              {STEPS.map((label, i) => (
                <div key={label} className={`hs-step hs-step--${stepState(i)}`}>
                  <div className="hs-step-dot">
                    {stepState(i) === "done" ? <CheckIcon size={12} /> : i + 1}
                  </div>
                  <span className="hs-step-label">{label}</span>
                </div>
              ))}
            </div>

            {/* Step 0 */}
            {step === 0 && (
              <div className="hs-issue-opts">
                {ISSUE_OPTS.map((opt) => (
                  <button
                    key={opt.id}
                    className={`hs-issue-opt${selected === opt.id ? " hs-issue-opt--selected" : ""}`}
                    onClick={() => setSelected(opt.id)}
                  >
                    <div
                      className="hs-issue-opt-icon"
                      style={{ background: opt.bg, color: opt.color }}
                    >
                      {opt.icon}
                    </div>
                    <span>{opt.label}</span>
                  </button>
                ))}
              </div>
            )}

            {/* Step 1 */}
            {step === 1 && (
              <textarea
                className="hs-textarea"
                placeholder="Describe your issue in detail — what happened, when, and any error messages you saw..."
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            )}

            {/* Step 2 */}
            {step === 2 && (
              <div style={{ marginBottom: 24 }}>
                <div
                  style={{
                    background: "#F5F3FF",
                    borderRadius: 12,
                    padding: "16px 20px",
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      color: "#7C3AED",
                      fontWeight: 700,
                      marginBottom: 4,
                      fontFamily: "Syne, sans-serif",
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                    }}
                  >
                    Issue Type
                  </div>
                  <div style={{ fontSize: 14, color: "#0F0E17" }}>
                    {ISSUE_OPTS.find((o) => o.id === selected)?.label}
                  </div>
                </div>
                <div
                  style={{
                    background: "#F5F3FF",
                    borderRadius: 12,
                    padding: "16px 20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      color: "#7C3AED",
                      fontWeight: 700,
                      marginBottom: 4,
                      fontFamily: "Syne, sans-serif",
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                    }}
                  >
                    Description
                  </div>
                  <div
                    style={{ fontSize: 14, color: "#0F0E17", lineHeight: 1.6 }}
                  >
                    {desc}
                  </div>
                </div>
              </div>
            )}

            <div className="hs-modal-footer">
              {step > 0 && (
                <button
                  className="hs-btn hs-btn--ghost"
                  style={{ background: "#F1F0F5", color: "#6B6882" }}
                  onClick={() => setStep((s) => s - 1)}
                >
                  Back
                </button>
              )}
              <button
                className="hs-btn hs-btn--primary"
                onClick={submit}
                disabled={
                  (step === 0 && !selected) || (step === 1 && !desc.trim())
                }
                style={{
                  opacity:
                    (step === 0 && !selected) || (step === 1 && !desc.trim())
                      ? 0.5
                      : 1,
                }}
              >
                {step === 2 ? "Submit Report" : "Continue"}{" "}
                <ArrowRightIcon size={14} />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// ─── ROOT COMPONENT ──────────────────────────────────────────────────────────

const HelpSupportPage = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <MyStudentLayout>
      <div className="hs-page">
        <QuickActions onReport={() => setModalOpen(true)} />
        <HelpCategories />
        <FaqSection />
        <StillNeedHelp onReport={() => setModalOpen(true)} />
        <MyTickets />

        {modalOpen && <ReportModal onClose={() => setModalOpen(false)} />}
      </div>
    </MyStudentLayout>
  );
};

export default HelpSupportPage;